import { Routes } from "@angular/router";
import { LoginGuard } from "./auth/login-guard.service";
import { HomePageUrlService } from "./platform/api/url-guards/home-page-url.service";
import { AccessDeniedComponent } from "./platform/error/access-denied/access-denied.component";
import { PageNotFoundComponent } from "./platform/error/page-not-found/page-not-found.component";
import { PlatformComponent } from "./platform/platform.component";
const ɵ0 = () => import("./auth/auth.module.ngfactory").then(m => m.AuthModuleNgFactory), ɵ1 = () => import("./platform/modules/reporting/reporting.module.ngfactory").then(m => m.ReportingModuleNgFactory), ɵ2 = { preload: true }, ɵ3 = () => import("./platform/modules/admin/admin.module.ngfactory").then(m => m.AdminModuleNgFactory), ɵ4 = { preload: true };
const routes = [
    { path: "login", loadChildren: ɵ0 },
    {
        path: "",
        component: PlatformComponent,
        children: [
            { path: "", canActivate: [HomePageUrlService], component: HomePageUrlService },
            { path: "reporting", loadChildren: ɵ1, data: ɵ2 },
            { path: "admin", loadChildren: ɵ3, data: ɵ4 },
            { path: "403", component: AccessDeniedComponent },
            { path: "404", component: PageNotFoundComponent },
        ],
        canActivate: [LoginGuard],
    },
    { path: "**", redirectTo: "404" },
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4 };
